import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/apiClient";
import { AdminHeader, AdminPage } from "@/components/admin/AdminUI";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

function Field({ label, children }) { return <div className="space-y-1.5"><label className="label-eyebrow text-slate-500 block">{label}</label>{children}</div>; }

const ABOUT_FIELDS = [
  ["who_we_are", "Who We Are"], ["our_purpose", "Our Purpose"],
  ["institutional_approach", "Institutional Approach"], ["public_accountability", "Public Accountability"],
  ["legal_policy_intervention", "Legal & Policy Intervention"],
];

export default function PagesAdmin() {
  const [about, setAbout] = useState({});
  const [mv, setMv] = useState({});
  useEffect(() => {
    api.get("/pages/about").then(({ data }) => setAbout(data.content || {})).catch(() => {});
    api.get("/pages/mission_vision").then(({ data }) => setMv(data.content || {})).catch(() => {});
  }, []);
  const saveAbout = async () => { await api.put("/pages/about", { content: about }); toast.success("About page saved"); };
  const saveMv = async () => { await api.put("/pages/mission_vision", { content: mv }); toast.success("Mission & Vision saved"); };

  return (
    <>
      <AdminHeader title="Institutional Pages" subtitle="Edit About, Mission & Vision content" />
      <AdminPage>
        <Tabs defaultValue="about">
          <TabsList className="mb-6"><TabsTrigger value="about">About</TabsTrigger><TabsTrigger value="mv">Mission & Vision</TabsTrigger></TabsList>
          <TabsContent value="about">
            <div className="bg-white border border-slate-200 rounded-lg p-6 space-y-5 max-w-3xl">
              {ABOUT_FIELDS.map(([k, label]) => (
                <Field key={k} label={label}><Textarea rows={3} value={about[k] || ""} onChange={(e) => setAbout((p) => ({ ...p, [k]: e.target.value }))} data-testid={`about-${k}`} /></Field>
              ))}
              <Button onClick={saveAbout} className="bg-npst-navy text-white" data-testid="save-about-btn">Save About</Button>
            </div>
          </TabsContent>
          <TabsContent value="mv">
            <div className="bg-white border border-slate-200 rounded-lg p-6 space-y-5 max-w-3xl">
              <Field label="Mission"><Textarea rows={4} value={mv.mission || ""} onChange={(e) => setMv((p) => ({ ...p, mission: e.target.value }))} data-testid="mv-mission" /></Field>
              <Field label="Vision"><Textarea rows={4} value={mv.vision || ""} onChange={(e) => setMv((p) => ({ ...p, vision: e.target.value }))} data-testid="mv-vision" /></Field>
              <Field label="Core Values (one per line)"><Textarea rows={6} value={(mv.core_values || []).join("\n")} onChange={(e) => setMv((p) => ({ ...p, core_values: e.target.value.split("\n").map((x) => x.trim()).filter(Boolean) }))} /></Field>
              <Button onClick={saveMv} className="bg-npst-navy text-white" data-testid="save-mv-btn">Save Mission & Vision</Button>
            </div>
          </TabsContent>
        </Tabs>
      </AdminPage>
    </>
  );
}
